<script setup lang="ts">
import KpSelectField from '@/components/KpSelectField.vue';
import { globalMandantKantonCollection } from '@/models/Kanton';
import type { Ref } from 'vue';

const value: Ref<any> = defineModel();

const props = defineProps<{
    label?: string;
}>();

const kantone = globalMandantKantonCollection();
</script>
<template>
    <KpSelectField
        :label="label"
        v-model="value"
        :options="kantone.getModels()"
        option-label="bezeichnung"
        option-value="id"
    ></KpSelectField>
</template>
